var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoge"},[_c('header-item1'),_c('div',{staticClass:"hoge--hoge"},[_vm._v("hogehoge")]),_c('hello-world',{attrs:{"msg":"Welcome to Your Vue.js App"}}),_c('level2-heading',[_vm._v("h2タグです。")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }